import React from 'react';

import { getParlevelQuantityDecimals } from '../../../common/utils/utils';
import InputNumber from './InputNumber';
import InputNumberPrefixed from './InputNumberPrefixed';
import InputNumberSuffixed from './InputNumberSuffixed';

const InputParlevelQuantity = ({ product, suffix, prefix, autoFocus, ...props }) => {

	const decimals = getParlevelQuantityDecimals(product);

	let Component = InputNumber;

	if (prefix) {
		Component = InputNumberPrefixed;
	}
	else if (suffix) {
		Component = InputNumberSuffixed;
	}

	return (
		<Component
			{...props}
			suffix={suffix}
			prefix={prefix}
			placeholder={decimals === 2 ? '0.00' : undefined}
			multiplyByHundred={decimals === 2}
			decimalPlaces={decimals}
			roundToSignificantFigures={true}
			autoFocus={autoFocus}
		/>
	);
};

export default InputParlevelQuantity;
